/**
 * User Roles Enum
 * Defines all available feature permissions in the system
 * Based on TIXApp.Web role structure
 */
export enum UserRole {
  // Market Information
  BALTIC = 'BALTIC',
  CARGO_COUNT = 'CARGO_COUNT',
  BUNKER_PRICES = 'BUNKER_PRICES',
  DAILY_REPORT = 'DAILY_REPORT',
  RECENT_FIXTURES = 'RECENT_FIXTURES',

  // Chartering
  FIXTURES = 'FIXTURES',
  POSITION_LIST = 'POSITION_LIST',
  CARGO_LIST = 'CARGO_LIST',

  // Pool Financial
  FIXED_DAYS = 'FIXED_DAYS',
  MONTHLY_REPORTS = 'MONTHLY_REPORTS',
  ANNUAL_REPORTS = 'ANNUAL_REPORTS',
  REPORTS_FILES = 'REPORTS_FILES',
  REPORTS_FILES_ADMIN = 'REPORTS_FILES_ADMIN',

  // Reports
  REPORTS = 'REPORTS',
  POWERBI_BASIC = 'POWERBI_BASIC',
  POWERBI_PRIVILEGED = 'POWERBI_PRIVILEGED',
  POWERBI_PRIVILEGED_KPC = 'POWERBI_PRIVILEGED_KPC',

  // Administration
  USERS = 'USERS',
  USER_GROUPS = 'USER_GROUPS',
  COMPANIES = 'COMPANIES',
  USER_ADMINISTRATION = 'USER_ADMINISTRATION',
}

/**
 * Permission check configuration
 * Supports both OR (any) and AND (all) logic
 */
export interface PermissionCheck {
  roles: UserRole[];
  requireAll?: boolean; // If true, uses AND logic; if false/undefined, uses OR logic
}

/**
 * User permission data structure
 */
export interface UserPermissions {
  roleCodes: UserRole[];
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
}

/**
 * Route configuration with permission requirements
 */
export interface ProtectedRouteConfig {
  path: string;
  requiredRoles?: UserRole[];
  requireAll?: boolean;
  fallbackPath?: string;
}

/**
 * Menu item with permission requirements
 */
export interface MenuItemPermission {
  roles?: UserRole[];
  requireAll?: boolean;
}
